export default "__VITE_ASSET__D3ue5qte__ 584w";